import { useQuery } from '@tanstack/react-query'
import { fetchPricingPlans } from '../subscriptions'

export const pricingPlansQueryKey = (slug: string) => [slug, 'stripe', 'pricing-plans'] as const

export const pricingPlansQueryOptions = (slug: string) => ({
  queryKey: pricingPlansQueryKey(slug),
  queryFn: () => fetchPricingPlans({ slug })
})

export const usePricingPlans = (slug: string) => useQuery(pricingPlansQueryOptions(slug))
